var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.14286C2 3.40711 3.40711 2 5.14286 2H14.2857C16.0215 2 17.4286 3.40711 17.4286 5.14286V6.57143H18.8571C20.5929 6.57143 22 7.97853 22 9.71429V18.8571C22 20.5929 20.5929 22 18.8571 22H9.71429C7.97853 22 6.57143 20.5929 6.57143 18.8571V17.4286H5.14286C3.40711 17.4286 2 16.0215 2 14.2857V5.14286ZM8.28571 18.8571C8.28571 19.6461 8.92531 20.2857 9.71429 20.2857H18.8571C19.6461 20.2857 20.2857 19.6461 20.2857 18.8571V9.71429C20.2857 8.92531 19.6461 8.28571 18.8571 8.28571H9.71429C8.92531 8.28571 8.28571 8.92531 8.28571 9.71429V18.8571ZM15.7143 6.57143H9.71429C7.97853 6.57143 6.57143 7.97853 6.57143 9.71429V15.7143H5.14286C4.35388 15.7143 3.71429 15.0747 3.71429 14.2857V5.14286C3.71429 4.35388 4.35388 3.71429 5.14286 3.71429H14.2857C15.0747 3.71429 15.7143 4.35388 15.7143 5.14286V6.57143Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyJob);
export default __webpack_public_path__ + "static/media/copy-job.52bdf88d55c0c969504cf114cf533e53.svg";
export { ForwardRef as ReactComponent };